import { useEffect, useState } from 'react';
import { getAlertsCount } from '../lib/api';

/**
 * Best-effort critical-only Alerts count for the AppShell pill.
 * Never blocks first paint; failures leave the count at 0.
 */
export function useAlertsCount(slug: string | undefined): number {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!slug) {
      setCount(0);
      return;
    }
    let cancelled = false;
    getAlertsCount(slug).then(
      (r) => {
        if (!cancelled) setCount(r.critical);
      },
      () => {
        /* swallow — pill is best-effort */
      }
    );
    return () => {
      cancelled = true;
    };
  }, [slug]);
  return count;
}
